import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandUsers,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AdminMenu from "../../AdminMenu";

const StoreManagementList = () => {
  const navigate = useNavigate();

  const [storeInfoData, setStoreInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let enabledGeoFencingModel= brandProfileData.enabledGeoFencingModel;
  const [loading, setLoading] = useState(false);

  const fetchStoreUser = () => {
    setLoading(true);
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreInfoData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

   const fetchFranchiseStore = async () => {
      const franchiseStore = await getLocalFranchiseStore();
      if (franchiseStore.franchiseStore !== null) {
        const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");        
        setStoreInfoData(Res);
      } else {
        setStoreInfoData([]);
      }
    };
      

  useEffect(() => {
    if (userRole === "BY_FRANCHISE_ADMIN") {
      fetchFranchiseStore();
    } else {
      fetchStoreUser();
    }
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const filterUserList = () => {
    return storeInfoData.filter((item) => {
      const fullName = item.storeName?.toLowerCase();
      const matchesSearchTerm = fullName?.includes(searchTerm.toLowerCase());
      return matchesSearchTerm;
    });
  };

  const filteredUserData = filterUserList();

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      let formattedRegistrationDate = item.createdDate
        ? formatDate(item.createdDate)
        : "";
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Store Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.storeName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Store Code :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.storeCode}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Registration Date :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {formattedRegistrationDate}
                    </p>
                  </div>
                  {userRole === "BY_FRANCHISE_ADMIN" ? "" : 
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/StoreManagementCreate", {
                        state: {
                          id: item.id,
                          upiData: null,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>}
                  <div
                    className="mr-4 mt-2 cursor-pointer"
                    onClick={() =>
                      navigate("/StoreConfigList", {
                        state: { id: item.id, StoreData: item },
                      })
                    }
                  >
                    <img
                      src="Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                      alt="config"
                      style={{
                        width: 50,
                      }}
                    />
                  </div>
                  {enabledGeoFencingModel && <div
                    className="mr-4 mt-2 cursor-pointer"
                    onClick={() =>
                      navigate("/GeoLocation", {
                        state: { id: item.id, StoreData: item },
                      })
                    }
                  >
                    <img
                      src="/warehouse/place.png"
                      alt="config"
                      style={{
                        width: 35,
                      }}
                    />
                  </div>}
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Invoice Gen No. :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.storeInvoiceGenNo}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Invoice Gen Name:
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.storeInvoiceGenName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Email Id :
                  </p>
                  <p className="text-lg font-medium">{item.email}</p>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-2 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Mobile Number :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.mobileNo}
                  </p>
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 2,
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Address :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.address.fullAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        {userRole === "BY_FRANCHISE_ADMIN" ? (
          ""
        ) : (
          <div
            onClick={() =>
              navigate("/StoreManagementCreate", {
                state: {
                  id: null,
                  upiData: null,
                },
              })
            }
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          >
            <div>
              <img
                src={
                  "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
                }
                style={{ width: 27 }}
              />
            </div>
          </div>
        )}
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Store"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        <div
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          onClick={() => setSearchTerm("")}
        >
          <div>
            <p className="text-4xl font-bold " style={{ color: "red" }}>
              X
            </p>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(filteredUserData || storeInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Order Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />

       
    </div>
  );
};

export default StoreManagementList;
